import * as styles from './rating-history-rating-cell-container.scss';

type PropsType = {
    children: React.ReactNode;
    originUrl?: string | null;
};

export function RatingHistoryRatingCellContainer(props: PropsType): JSX.Element {
    const {children, originUrl} = props;
    const href = originUrl?.trim();

    if (href) {
        return (
            <a
                className={styles.RatingHistoryRatingCellContainer}
                href={href}
                rel="noopener noreferrer"
                target="_blank"
            >
                {children}
            </a>
        );
    }

    return <div className={styles.RatingHistoryRatingCellContainer}>{children}</div>;
}
